import { Link } from 'gatsby'
import React, { memo } from 'react'

// example
{
  /*  <LinkToAuthor
        to={linkResolver(page?.article_author)}
        data={{ type: page.article_overview, article: data.prismicArticlePage }}
    >    */
}

const LinkToAuthor = ({ children, to, data, className }) => {
  const { type, article } = data
  return (
    <Link
      to={to}
      state={{
        type,
        article,
      }}
      className={className}
    >
      {children}
    </Link>
  )
}

export default memo(LinkToAuthor)
